export const LOCK_SHIFT_PERMISSION = {
  VIEW: 'MD_LOCKSHIFT_VIEW',
  EDIT: 'MD_LOCKSHIFT_EDIT',
  CLOSE_CREATE: 'MD_LOCKSHIFT_CLOSE_CREATE',
  HANDOVER_CONFIRM: 'MD_LOCKSHIFT_HANDOVER_CONFIRM',
};

export const LOCK_SHIFT_FORM_PERMISSIONS = [
  LOCK_SHIFT_PERMISSION.CLOSE_CREATE,
  LOCK_SHIFT_PERMISSION.HANDOVER_CONFIRM,
  LOCK_SHIFT_PERMISSION.EDIT,
];
